import { connect } from 'react-redux'
import invoicePdfComponent from '../../components/invoice/invoicePdf.component'

const mapStateToProps = (state) => {
  const invoice = state.invoiceReviews.formValues
  const { client } = state
  const userType = client.user.data[5]

  return {
    state,
    invoice,
    userName: state.profile.userData.useMarketName
      ? state.profile.userData.market_name
      : `${state.profile.userData.firstname} ${state.profile.userData.lastname}`,
    originalInvoiceId: state.invoice.originalInvoiceId,
    userType,
    userEmail: state.profile.userData.email
  }
}

const invoicePdfContainer = connect(mapStateToProps, null)(invoicePdfComponent)

export default invoicePdfContainer
